import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { EavEntityTypeFindInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

import * as yup from 'yup';

/** Deal type create or update parameters */
export interface DealTypeFormInterface {
  /** Deal type display name */
  name: string;
  /** If `true` then this deal type is default for rental deals and cannot be deleted */
  isRentDefault?: boolean;
  /** Default company identifier */
  defaultCompany?: OnlyIdRequiredInterface<CompanyFindInterface>;
  /** Default nomenclature item identifiers */
  defaultNomenclatures?: OnlyIdRequiredInterface<NomenclatureItemFindInterface>[];
  /** Responsible user identifier */
  responsible?: OnlyIdRequiredInterface<UserFindInterface>;
  /** Auditor user identifiers */
  auditorUsers?: OnlyIdRequiredInterface<UserFindInterface>[];
  /** Auditor group identifiers */
  auditorGroups?: OnlyIdRequiredInterface<UserGroupFindInterface>[];
  /** EAV entity type identifier */
  eavEntityType?: OnlyIdRequiredInterface<EavEntityTypeFindInterface>;
}

/** Deal type create or update parameters - DTO schema */
export const DealTypeFormDto = SerdeDtoClass.create<DealTypeFormInterface>(BusinessDtoKeysEnum.DEAL_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .required(DtoMessageEnum.EMPTY_STRING),
  },
  isRentDefault: {
    optional: true,
    label: 'Тип по умолчанию для аренды',
    serializer: yup.boolean(),
  },
  defaultCompany: {
    optional: true,
    label: 'Компания по-умолчанию',
    serializer: entityLikeSchema,
  },
  defaultNomenclatures: {
    optional: true,
    label: 'Номенклатура по-умолчанию',
    serializer: yup.array(entityLikeSchema),
  },
  responsible: {
    optional: true,
    label: 'Ответственный',
    serializer: entityLikeSchema,
  },
  auditorUsers: {
    optional: true,
    label: 'Пользователи-аудиторы',
    serializer: yup.array(entityLikeSchema),
  },
  auditorGroups: {
    optional: true,
    label: 'Группы-аудиторы',
    serializer: yup.array(entityLikeSchema),
  },
  eavEntityType: {
    optional: true,
    label: 'Шаблон полей',
    serializer: entityLikeSchema,
  },
});

